<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="adc">
<p class="center">A<span class="small">LSO BY</span> E<span class="small">LIZABETH</span> A<span class="small">DLER</span></p>
<p class="center"><em>Meet Me in Venice</em><br/><em>Sailing to Capri<br/>The House in Amalfi<br/>Invitation to Provence<br/>The Hotel Riviera<br/>Summer in Tuscany<br/>The Last Time I Saw Paris<br/>In a Heartbeat<br/>Sooner or Later<br/>All or Nothing<br/>Now or Never<br/>Fleeting Images<br/>Indiscretions<br/>The Heiress<br/>The Secret of Villa Mimosa<br/>Legacy of Secrets<br/>Fortune Is a Woman<br/>The Property of a Lady<br/>The Rich Shall Inherit<br/>Peach<br/>Léonie</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312364496_epub_adc_r1.vue?5ca62f9e